module.exports = __webpack_public_path__ + "img/link-icon.306f6881.svg";